import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';
import { sleep } from '../../lib/sleep';

@Directive({
  selector: '[appAutofocus]',
  standalone: true,
})
export class AutofocusDirective implements AfterViewInit {
  private host = inject(ElementRef);

  async ngAfterViewInit() {
    await sleep(100);
    const el: HTMLElement = this.host.nativeElement;
    if (!['INPUT', 'TEXTAREA'].includes(el.tagName) && !el.hasAttribute('contenteditable')) {
      console.warn('Autofocus directive can only be used on input elements');
      return;
    }
    el.focus();
  }
}
